( function () {
	'use strict';

	function rubricOption () {
		return {
			'templateUrl' : '/templates/components/indicators/rubric/rubric-option.html',
			'restrict'    : 'E',
			'scope'       : {
				'option'     : '=',
				'ctrl'       : '=',
				'index'      : '=',
				'groupModel' : '=',
				'webview'    : '=',
				'inModal'    : '='
			}
		};
	}

	angular.module( 'app.components' )
		.directive( 'rubricOption', rubricOption );
} )( );
